import React from 'react'
import { Typography } from '@mui/material'
import { useStyles } from './DetailedSubscription.styles'

export type DetailedSubscriptionProps = {
  label: string
  value: string
  subValue?: string
}

export const DetailedSubscription = ({
  label,
  value,
  subValue,
}: DetailedSubscriptionProps) => {
  const { classes } = useStyles()
  return (
    <div className={classes.gridRoot}>
      <Typography
        className={classes.label}
        data-testid="detailed-subscription-label"
      >
        {label}
      </Typography>
      <Typography className={classes.value}>{value}</Typography>
      <Typography className={classes.subValue}>{subValue}</Typography>
    </div>
  )
}
